import { Country } from "../Country.js";

export const countryToIsoCodeMap = {
	[Country.Afghanistan]: "AF",
	[Country.Albania]: "AL",
	[Country.Algeria]: "DZ",
	[Country.Andorra]: "AD",
	[Country.Angola]: "AO",
	[Country.AntiguaAndBarbuda]: "AG",
	[Country.Argentina]: "AR",
	[Country.Armenia]: "AM",
	[Country.Australia]: "AU",
	[Country.Austria]: "AT",
	[Country.Azerbaijan]: "AZ",
	[Country.Bahamas]: "BS",
	[Country.Bahrain]: "BH",
	[Country.Bangladesh]: "BD",
	[Country.Barbados]: "BB",
	[Country.Belarus]: "BY",
	[Country.Belgium]: "BE",
	[Country.Belize]: "BZ",
	[Country.Benin]: "BJ",
	[Country.Bhutan]: "BT",
	[Country.Bolivia]: "BO",
	[Country.BosniaAndHerzegovina]: "BA",
	[Country.Botswana]: "BW",
	[Country.Brazil]: "BR",
	[Country.Brunei]: "BN",
	[Country.Bulgaria]: "BG",
	[Country.BurkinaFaso]: "BF",
	[Country.Burundi]: "BI",
	[Country.CaboVerde]: "CV",
	[Country.Cambodia]: "KH",
	[Country.Cameroon]: "CM",
	[Country.Canada]: "CA",
	[Country.CentralAfricanRepublic]: "CF",
	[Country.Chad]: "TD",
	[Country.Chile]: "CL",
	[Country.China]: "CN",
	[Country.Colombia]: "CO",
	[Country.Comoros]: "KM",
	[Country.Congo]: "CG",
	[Country.CostaRica]: "CR",
	[Country.CoteDIvoire]: "CI",
	[Country.Croatia]: "HR",
	[Country.Cuba]: "CU",
	[Country.Cyprus]: "CY",
	[Country.Czechia]: "CZ",
	[Country.DemocraticRepublicOfTheCongo]: "CD",
	[Country.Denmark]: "DK",
	[Country.Djibouti]: "DJ",
	[Country.Dominica]: "DM",
	[Country.DominicanRepublic]: "DO",
	[Country.Ecuador]: "EC",
	[Country.Egypt]: "EG",
	[Country.ElSalvador]: "SV",
	[Country.EquatorialGuinea]: "GQ",
	[Country.Eritrea]: "ER",
	[Country.Estonia]: "EE",
	[Country.Eswatini]: "SZ",
	[Country.Ethiopia]: "ET",
	[Country.Fiji]: "FJ",
	[Country.Finland]: "FI",
	[Country.France]: "FR",
	[Country.Gabon]: "GA",
	[Country.Gambia]: "GM",
	[Country.Georgia]: "GE",
	[Country.Germany]: "DE",
	[Country.Ghana]: "GH",
	[Country.Greece]: "GR",
	[Country.Grenada]: "GD",
	[Country.Guatemala]: "GT",
	[Country.Guinea]: "GN",
	[Country.GuineaBissau]: "GW",
	[Country.Guyana]: "GY",
	[Country.Haiti]: "HT",
	[Country.Honduras]: "HN",
	[Country.Hungary]: "HU",
	[Country.Iceland]: "IS",
	[Country.India]: "IN",
	[Country.Indonesia]: "ID",
	[Country.Iran]: "IR",
	[Country.Iraq]: "IQ",
	[Country.Ireland]: "IE",
	[Country.Israel]: "IL",
	[Country.Italy]: "IT",
	[Country.Jamaica]: "JM",
	[Country.Japan]: "JP",
	[Country.Jordan]: "JO",
	[Country.Kazakhstan]: "KZ",
	[Country.Kenya]: "KE",
	[Country.Kiribati]: "KI",
	[Country.Kuwait]: "KW",
	[Country.Kyrgyzstan]: "KG",
	[Country.Laos]: "LA",
	[Country.Latvia]: "LV",
	[Country.Lebanon]: "LB",
	[Country.Lesotho]: "LS",
	[Country.Liberia]: "LR",
	[Country.Libya]: "LY",
	[Country.Liechtenstein]: "LI",
	[Country.Lithuania]: "LT",
	[Country.Luxembourg]: "LU",
	[Country.Madagascar]: "MG",
	[Country.Malawi]: "MW",
	[Country.Malaysia]: "MY",
	[Country.Maldives]: "MV",
	[Country.Mali]: "ML",
	[Country.Malta]: "MT",
	[Country.MarshallIslands]: "MH",
	[Country.Mauritania]: "MR",
	[Country.Mauritius]: "MU",
	[Country.Mexico]: "MX",
	[Country.Micronesia]: "FM",
	[Country.Moldova]: "MD",
	[Country.Monaco]: "MC",
	[Country.Mongolia]: "MN",
	[Country.Montenegro]: "ME",
	[Country.Morocco]: "MA",
	[Country.Mozambique]: "MZ",
	[Country.Myanmar]: "MM",
	[Country.Namibia]: "NA",
	[Country.Nauru]: "NR",
	[Country.Nepal]: "NP",
	[Country.Netherlands]: "NL",
	[Country.NewZealand]: "NZ",
	[Country.Nicaragua]: "NI",
	[Country.Niger]: "NE",
	[Country.Nigeria]: "NG",
	[Country.NorthKorea]: "KP",
	[Country.NorthMacedonia]: "MK",
	[Country.Norway]: "NO",
	[Country.Oman]: "OM",
	[Country.Pakistan]: "PK",
	[Country.Palau]: "PW",
	[Country.Panama]: "PA",
	[Country.PapuaNewGuinea]: "PG",
	[Country.Paraguay]: "PY",
	[Country.Peru]: "PE",
	[Country.Philippines]: "PH",
	[Country.Poland]: "PL",
	[Country.Portugal]: "PT",
	[Country.Qatar]: "QA",
	[Country.Romania]: "RO",
	[Country.Russia]: "RU",
	[Country.Rwanda]: "RW",
	[Country.SaintKittsAndNevis]: "KN",
	[Country.SaintLucia]: "LC",
	[Country.SaintVincentAndTheGrenadines]: "VC",
	[Country.Samoa]: "WS",
	[Country.SanMarino]: "SM",
	[Country.SaoTomeAndPrincipe]: "ST",
	[Country.SaudiArabia]: "SA",
	[Country.Senegal]: "SN",
	[Country.Serbia]: "RS",
	[Country.Seychelles]: "SC",
	[Country.SierraLeone]: "SL",
	[Country.Singapore]: "SG",
	[Country.Slovakia]: "SK",
	[Country.Slovenia]: "SI",
	[Country.SolomonIslands]: "SB",
	[Country.Somalia]: "SO",
	[Country.SouthAfrica]: "ZA",
	[Country.SouthKorea]: "KR",
	[Country.SouthSudan]: "SS",
	[Country.Spain]: "ES",
	[Country.SriLanka]: "LK",
	[Country.Sudan]: "SD",
	[Country.Suriname]: "SR",
	[Country.Sweden]: "SE",
	[Country.Switzerland]: "CH",
	[Country.Syria]: "SY",
	[Country.Taiwan]: "TW",
	[Country.Tajikistan]: "TJ",
	[Country.Tanzania]: "TZ",
	[Country.Thailand]: "TH",
	[Country.TimorLeste]: "TL",
	[Country.Togo]: "TG",
	[Country.Tonga]: "TO",
	[Country.TrinidadAndTobago]: "TT",
	[Country.Tunisia]: "TN",
	[Country.Turkey]: "TR",
	[Country.Turkmenistan]: "TM",
	[Country.Tuvalu]: "TV",
	[Country.Uganda]: "UG",
	[Country.Ukraine]: "UA",
	[Country.UnitedArabEmirates]: "AE",
	[Country.UnitedKingdom]: "GB",
	[Country.UnitedStates]: "US",
	[Country.Uruguay]: "UY",
	[Country.Uzbekistan]: "UZ",
	[Country.Vanuatu]: "VU",
	[Country.VaticanCity]: "VA",
	[Country.Venezuela]: "VE",
	[Country.Vietnam]: "VN",
	[Country.Yemen]: "YE",
	[Country.Zambia]: "ZM",
	[Country.Zimbabwe]: "ZW",
} as const satisfies Record<Country, string>;
